import {
  getCollaboratorInviteContext,
  getCollaboratorRoleContext,
} from "@/services/public/collaboratorSessionService";

export function collaboratorFlowGuard(to, from, next) {
  const inviteContext = getCollaboratorInviteContext();
  const roleContext = getCollaboratorRoleContext();

  if (!inviteContext?.invite_token) {
    next({ name: "login-comp" });
    return;
  }

  if (!roleContext?.role_id) {
    next({ name: "login-collab" });
    return;
  }

  next();
}
